import { render } from "./IconCircleCheckClassicRegular.vue?vue&type=template&id=fb41f4fe"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__